module.exports = __webpack_public_path__ + "img/Trophy.6a155954.svg";